import { firestore, geofirestore, } from "firebaseHelpers";
import Moment from 'moment'
import { CANCELED, WAIT_ACCEPT, HAS_CHECKOUT_NEEDS_RATING, REFUSED, } from 'constants/bookingStatus'
import { getUserInfos, } from './users'

const fetchBookingsFilter = (filters, userId = null, parkingId = null, limit) => {
  let bookingsQuery = userId ? firestore.collection('users').doc(userId).collection('reservations') : (parkingId ? firestore.collection('parkings').doc(parkingId).collection('reservations') : firestore.collection('reservations'))

  if (filters) {
    if (typeof filters.userFirstName !== 'undefined' && filters.userFirstName !== '') {
      bookingsQuery = bookingsQuery.where('userFirstName', '==', filters.userFirstName)
    }
    if (typeof filters.userLastName !== 'undefined' && filters.userLastName !== '') {
      bookingsQuery = bookingsQuery.where('userLastName', '==', filters.userLastName)
    }
    if (typeof filters.userEmail !== 'undefined' && filters.userEmail !== '') {
      bookingsQuery = bookingsQuery.where('userEmail', '==', filters.userEmail)
    }
    if (typeof filters.reference !== 'undefined' && filters.reference !== '') {
      bookingsQuery = bookingsQuery.where('reference', '==', filters.reference)
    }
    if (typeof filters.status !== 'undefined' && filters.status !== '') {
      bookingsQuery = bookingsQuery.where('status', '==', Number(filters.status))
    }
    if (typeof filters.parkingId !== 'undefined' && filters.parkingId !== '') {
      bookingsQuery = bookingsQuery.where('parkingId', '==', filters.parkingId)
    }
    if (typeof filters.numberPlate !== 'undefined' && filters.numberPlate !== '') {
      bookingsQuery = bookingsQuery.where('numberPlate', '==', filters.numberPlate)
    }
    if (typeof filters.fromTo.startDate !== 'undefined' && filters.fromTo.startDate !== '') {
      bookingsQuery = bookingsQuery.where('from', '>=', filters.fromTo.startDate.toDate())
    }
    if (typeof filters.fromTo.endDate !== 'undefined' && filters.fromTo.endDate !== '') {
      bookingsQuery = bookingsQuery.where('to', '<', filters.fromTo.endDate.toDate())
    }
  }
  if (limit) {
    bookingsQuery = bookingsQuery.orderBy('reservationDate').limit(limit)
  }
  return bookingsQuery
}

export const fetchParkingBookings = async (filters, parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let bookingsList = []

      bookingsList = await fetchBookingsFilter(filters, null, parkingId).get()
      const formatedData = bookingsList.docs.map((booking) => {
        const data = booking.data()
        return {
          ...data,
          id: booking.id,
          from: data.from.toDate(),
          to: data.to.toDate(),
          reservationDate: data.reservationDate.toDate(),
        }
      })
      const sortedBookings = formatedData.sort((a, b) => {
        const momentA = Moment(a.reservationDate)
        const momentB = Moment(b.reservationDate)

        if (momentA.isAfter(momentB)) {
          return -1
        }
        if (momentA.isBefore(momentB)) {
          return 1
        }
        return 0
      })
      resolve(sortedBookings)
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchBookings = async (filters, userId, restrictedParkings = null, limit) => {
  return new Promise(async (resolve, reject) => {
    try {
      let bookingsList = []

      if (restrictedParkings) {
        const bookingsQuery = await Promise.all(restrictedParkings.map((parking) => (fetchBookingsFilter(filters, userId, null, limit).where('parkingId', '==', parking).get())))
        bookingsList = bookingsQuery.reduce((acc, booking) => {
          return { docs: [ ...acc.docs, ...booking.docs ] }
        }, { docs: [] })
      } else {
        bookingsList = await fetchBookingsFilter(filters, userId, null, limit).get()
      }
      const formatedData = bookingsList.docs.map((booking) => {
        const data = booking.data()
        return {
          ...data,
          id: booking.id,
          from: data.from.toDate(),
          to: data.to.toDate(),
          reservationDate: data.reservationDate.toDate(),
          status: Number(data.status),
        }
      })
      const sortedBookings = formatedData.sort((a, b) => {
        const momentA = Moment(a.reservationDate)
        const momentB = Moment(b.reservationDate)

        if (momentA.isAfter(momentB)) {
          return -1
        }
        if (momentA.isBefore(momentB)) {
          return 1
        }
        return 0
      })
      resolve(sortedBookings)
    } catch (error) {
      reject(error.message)
    }
  })
}

export const deleteBooking = async (booking) => {
  return new Promise(async (resolve, reject) => {
    try {
      await firestore.collection('reservations').doc(booking.id).delete()
      await firestore.collection('users').doc(booking.userId).collection('reservations').doc(booking.id).delete()
      await geofirestore.collection('parkings').doc(booking.parkingId).collection('reservations').doc(booking.id).delete()

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const cancelBooking = async (booking) => {
  return new Promise(async (resolve, reject) => {
    try {
      const currentTime = Moment()

      if (booking.status === CANCELED) {
        reject({ message: 'The booking is already canceled' })
      } else if (Moment(booking.from).isBefore(currentTime)) {
        reject({ message: 'The booking has already ended' })
      }
      const bookingInfos = firestore.collection('users').doc(booking.userId).collection('reservations').doc(booking.id)
      await bookingInfos.set({
        status: CANCELED,
      }, { merge: true })

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchBookingData = async (bookingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const bookingInfos = await firestore.collection('reservations').doc(bookingId).get()
      const data = bookingInfos.data()
      const formatedData = {
        ...data,
        id: bookingId,
        from: data.from.toDate(),
        to: data.to.toDate(),
        reservationDate: data.reservationDate.toDate(),
        customerData: data.customer ? await getUserInfos(data.customer.id) : null,
        ownerData: data.owner ? await getUserInfos(data.owner.id) : null,
        delegateData: data.delegate ? await getUserInfos(data.delegate.id) : null,
        status: Number(data.status)
      }
      resolve(formatedData)
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchPendingBookings = async (userInfos) => {
  return new Promise(async (resolve, reject) => {
    try {
      const bookings = await Promise.all(userInfos.parkings.map(async (parking) => {
        const booking = await firestore.collection('parkings').doc(parking.id).collection('reservations').where('status', '==', WAIT_ACCEPT).get()

        return booking.docs.length
      }))

      resolve(bookings.reduce((acc, nbBookings) => {
        return acc + nbBookings
      }, 0))
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchBookingsToRate = async (userInfos) => {
  return new Promise(async (resolve, reject) => {
    try {
      const bookings = await Promise.all(userInfos.parkings.map(async (parking) => {
        const booking = await firestore.collection('parkings').doc(parking.id).collection('reservations').where('status', '==', HAS_CHECKOUT_NEEDS_RATING).get()

        return booking.docs.length
      }))

      resolve(bookings.reduce((acc, nbBookings) => {
        return acc + nbBookings
      }, 0))
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchCancelationsPending = async (bookingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const bookingsCanceled = await firestore.collection('reservations').where('status', '==', CANCELED).get()
      const bookingsRefused = await firestore.collection('reservations').where('status', '==', REFUSED).get()

      resolve(bookingsCanceled.docs.length + bookingsRefused.docs.length)
    } catch (error) {
      reject(error.message)
    }
  })
}
